<template>
  <div class="w-100" v-if="!hideDiv">
    <div class="container-fluid px-0">
      <div class="row align-items-center mb-2 mx-0">
        <div class="col-12 col-lg-6 text-left px-0">
          <div
            class="w-100 d-flex align-items-end justify-content-between justify-content-lg-start"
          >
            <span class="rails-header-title"
              >More contents like {{ title }}</span
            >
          </div>
        </div>
      </div>
      <div
        class="row mx-0 latest-tv-rails-content"
        id="recommendation1RailsPlayerv2"
      >
        <div class="w-100">
          <div
            class="owl-carousel owl-theme"
            id="recommendation1RailsPlayerPageCarousel"
          >
            <div
              class="item"
              v-for="item_vod in data"
              :key="item_vod.id"
              @mouseover="mouseOver"
              @mouseout="mouseOver"
            >
              <vod-card
                :image="item_vod.img_link"
                :title="item_vod.longTitle"
                :link="item_vod.redirect_url"
                :latestTag="formatTimestamp(item_vod.dateAvailability)"
                :data="item_vod.data"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else></div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import ChevronRight from "../../../../../assets/rtmklik/svg/theme_chevron_right.svg";
import ChevronLeft from "../../../../../assets/rtmklik/svg/theme_chevron_left.svg";
import vodCard from "../../../../cards/v2/vodCard.vue";
export default {
  name: "player-page-recommendation-1",
  data: function() {
    return {
      hiburan_list: [],
      hover: false,
      hideDiv: false,
      data: [],
    };
  },
  props: ["contentID", "title"],
  components: { vodCard },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },

    sortCategories(obj) {
      const vm = this;
      vm.data = obj;
      if (vm.data.length > 0) {
        vm.hideDiv = false;
        var store = [];
        vm.data.forEach((item) => {
          var redirectLink = this.getAssetLink(item);
          var timecompare = this.formatTimestamp(item.dateAvailability);
          item["img_link"] = this.rtmImgLinkFiltering(
            item.data.images,
            "320x0"
          );
          item["redirect_url"] = redirectLink;
          item["shownewimage"] = timecompare;
          store.push(item);
        });

        vm.data = store.slice(0, 20);

        Vue.nextTick(
          function() {
            vm.installOwlCarousel("#recommendation1RailsPlayerPageCarousel");
          }.bind(vm)
        );
      } else {
        vm.hideDiv = true;
      }
    },
    async initializeCategoryForStart() {
      const userID = localStorage.getItem("user_id");

      try {
        let response = await axios.get(
          `https://rtmklik-recommendation.com/api/item-recommendation/${
            this.contentID
          }/${userID}`
        );

        var arr = response.data.data;
        this.sortCategories(response.data.data);
      } catch (e) {
        console.log(e);
        this.hideDiv = true;
      }
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 6,
        autoplay: false,
        loop: false,
        nav: false,
        dots: false,
        stagePadding: 0,
        responsiveClass: true,
        navText: [`<img src=${ChevronLeft} />`, `<img src=${ChevronRight} />`],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            margin: 8,
            stagePadding: 0,
          },
          768: {
            items: 4,
            stagePadding: 0,
            loop: false,
            margin: 8,
            nav: false,
          },
          992: {
            items: 5,
            stagePadding: 0,
            loop: false,
            margin: 6,
            nav: true,
          },
          1280: {
            items: 6,
            stagePadding: 2,
            loop: false,
            margin: 8,
            nav: true,
          },
        },
      });
    },

    formatString(str) {
      var lower = str.toLowerCase();
      return lower
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
  },

  mounted() {
    this.initializeCategoryForStart();
  },
};
</script>

<style scoped>
.carousel-main-height-wrapper {
  margin-bottom: 2rem;
}

@media only screen and (min-width: 992px) {
  .carousel-main-height-wrapper {
    margin-bottom: 10rem;
  }
}
</style>
<style>
.latest-tv-rails-content .owl-theme .owl-stage-outer {
  overflow: unset;
}

#recommendation1RailsPlayerv2 .owl-nav {
  display: none;
}

button:focus {
  outline: unset !important;
}

@media only screen and (min-width: 992px) {
  #recommendation1RailsPlayerv2 .owl-theme:hover {
    z-index: 111;
  }

  #recommendation1RailsPlayerv2 .owl-theme {
    height: auto;
  }
  #recommendation1RailsPlayerv2 .owl-item {
    z-index: 1;
  }
  #recommendation1RailsPlayerv2 .owl-item:hover {
    transition: 0.1s all ease-in-out;
    transform: scale(1.2);
    z-index: 2000;
  }

  #recommendation1RailsPlayerv2 .owl-theme .owl-nav.disabled {
    display: none !important;
  }
  #recommendation1RailsPlayerv2 .owl-theme .owl-nav {
    position: absolute;
    top: -52px;
    right: 2px;
    width: 80px;
    display: flex;
    justify-content: space-between;
  }

  #recommendation1RailsPlayerv2 .owl-prev img {
    width: 22px;
    height: 23px;
  }

  #recommendation1RailsPlayerv2 .owl-next img {
    width: 22px;
    height: 23px;
  }
}
</style>
